/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Lastname1Inputs */

const en_entity_lastname1 = /** @type {(inputs: Entity_Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Name`)
};

const de_entity_lastname1 = /** @type {(inputs: Entity_Lastname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachname`)
};

/**
* | output |
* | --- |
* | "Last Name" |
*
* @param {Entity_Lastname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_lastname1 = /** @type {((inputs?: Entity_Lastname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Lastname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_lastname1(inputs)
	return de_entity_lastname1(inputs)
});
export { entity_lastname1 as "entity_lastName" }